import { getCurrentApi } from './baseAPI';

export const platformSettingsAPI = {
  get: async () => {
    const api = await getCurrentApi();
    const response = await api.get('/settings/platform');
    return response;
  },

  update: async (formData) => {
    const api = await getCurrentApi();
    const response = await api.put('/settings/platform', formData, {
      transformRequest: [(data, headers) => {
        delete headers['Content-Type'];
        return data;
      }]
    });
    return response;
  }
};

export default platformSettingsAPI;
